import { css } from 'linaria';

const root = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--rounding-m);
  width: 32px;
  height: 24px;
  cursor: pointer;
  background-color: var(--control-minor);

  svg {
    width: 13px !important;
  }
`;

const active = css`
  background-color: var(--control-primary);

  &:hover {
    background-color: var(--control-primary) !important;
  }
`;

export { root, active };
